// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__oOjVZ","rotation":"Spinner_rotation__sy86F"};